import { render, staticRenderFns } from "./TimelineSection.vue?vue&type=template&id=535bf13e&scoped=true"
import script from "./TimelineSection.vue?vue&type=script&lang=js"
export * from "./TimelineSection.vue?vue&type=script&lang=js"
import style0 from "./TimelineSection.vue?vue&type=style&index=0&id=535bf13e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535bf13e",
  null
  
)

export default component.exports